var _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import allPermissions from 'vagrant/utils/permissions';
var VagrantFeatures = /*#__PURE__*/function (VagrantFeatures) {
  VagrantFeatures["Architecture"] = "architecture";
  VagrantFeatures["Box"] = "box";
  VagrantFeatures["BoxFile"] = "boxfile";
  VagrantFeatures["Index"] = "index";
  VagrantFeatures["Provider"] = "provider";
  VagrantFeatures["Registry"] = "registry";
  VagrantFeatures["Version"] = "version";
  return VagrantFeatures;
}(VagrantFeatures || {});
let _class = (_class2 = class _class2 extends Service {
  constructor(owner) {
    super(owner);
    _initializerDefineProperty(this, "api", _descriptor, this);
    _initializerDefineProperty(this, "registry", _descriptor2, this);
    _initializerDefineProperty(this, "authzBuilder", _descriptor3, this);
    _initializerDefineProperty(this, "authz", _descriptor4, this);
    this.authzBuilder = allPermissions();

    // Assume no permissions before querying the resource manager
    this.authz = this.authzBuilder.apply([]);
  }
  async fetchPermissions(projectId) {
    // If there is no project, assume unauthenticated user and no permissions.
    if (!projectId) {
      this.authz = this.authzBuilder.apply([]);
      return;
    }
    const {
      allowedPermissions
    } = await this.api.resourceManager.project.projectServiceTestIamPermissions(projectId, {
      permissions: this.authzBuilder.list()
    });
    if (allowedPermissions) {
      this.authz = this.authzBuilder.apply(allowedPermissions);
    } else {
      throw new Error('Failed to fetch permissions, defaulting to no permissions');
    }
  }
  clearPermissions() {
    this.authz = this.authzBuilder.apply([]);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "api", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "registry", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "authzBuilder", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "authz", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export { _class as default };